import { Component, ElementRef, Inject, OnInit, PLATFORM_ID, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs/internal/Subscription';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from '../../shared/services/apiService.service';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  Validators,
} from '@angular/forms';
import { RegexService } from '../../shared/form-validation/regex.service';
import { FormErrorService } from '../../shared/form-validation/form-error.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { RootService } from '../../shared/services/root.service'
import { OwlOptions } from 'ngx-owl-carousel-o';
import { CommonService } from '../../shared/services/common.service';

import { isPlatformBrowser } from '@angular/common';
import { environment } from '../../../environments/environment';
import { ClevertapService } from '../../shared/services/clevertap/clevertap.service';
import { secureStorage } from '../../shared/services/encryption/secureservice';
import { ThankuResponse } from '../../shared/payload-Model/billingFormModel';
const url = 'assets/product-lead-script.js';
import * as unbxUrl from '../../../assets/unbx-script';
import { setImageUrl } from '../../fni-modules/shared/helper/common_function'
import { Meta } from '@angular/platform-browser';
function _window(): any {
  // return the global native browser window object
  if (isPlatformBrowser(this.platformId)) {
    return window;
  }
}
@Component({
  selector: 'app-finance-product-lead',
  templateUrl: './finance-product-lead.component.html',
  styleUrls: ['./finance-product-lead.component.scss'],
})
export class FinanceProductLeadComponent implements OnInit {
  environment1 = environment.s3bucket.url;
  productDetailList: any;
  offerData: any = [];
  productLoaded: boolean = false;
  sub: Subscription = new Subscription();
  id: any;
  totalAmount: any;
  bookingForm!: FormGroup;
  isSubmitForm: boolean = false;
  stateList: any[];
  districtList: any[];
  dealerList: any = [];
  showotp: boolean = false;
  divData: any;
  statedata: any[];
  disabledFields: boolean = false;
  disableMainFields: boolean = false;
  response: any;
  showCongratulationMsg: boolean = false;
  tractionSuccess: boolean;
  tractionfailed: boolean = false;
  offertrue: boolean = false;
  bannerImg: string;
  defaultbannerImg: string;
  reqID: any;
  Payresponse: any;
  leadData: any;
  userData: any;

  errormsg: any;
  m: any;
  s: any;
  timeLeft: any;
  isTimer: boolean = false;
  isLoading: any = false;
  bannerList: any;
  payMessage: string = '';
  imageUrl: string = '';

  customOptionsForBanner: OwlOptions = {
    loop: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    dots: true,
    navSpeed: 1200,
    autoplay: true,
    // nav: true,
    responsiveRefreshRate: 1000000,

    responsive: {
      0: {
        items: 1,
      },
      400: {
        items: 1,
      },
      740: {
        items: 1,
      },
      940: {
        items: 1,
      },
    },
  };
  loadAPI: Promise<any>;
  hideproceedbtn: boolean = false;
  pagetitle = 'Lead Booking';
  utm_source: any;
  utm_medium: any;
  utm_campaign: any;
  gclid: any;
  newVCPrice: any;
  encData: string;
  orderID: any;
  LeadDetailList: any;
  ccavenue: any;
  isDisabled: boolean = false;
  isSubmitted: boolean = false;
  dealerCode: string;
  financerData: any;
  imageSlider = {
    infinite: false,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    dots: true,
    autoplay: false,
    draggable: false,
    prevArrow: '.client-feedback .prev-arrow',
    nextArrow: '.client-feedback .next-arrow',
    asNavFor: '.thumbs,.popimagepreview,.popimgthumbs',
  };
  thumbSlider = {
    infinite: false,
    speed: 300,
    slidesToShow: 5,
    slidesToScroll: 5,
    asNavFor: '.imagepreview,.popimagepreview,.popimgthumbs',
    dots: false,
    autoplay: false,
    draggable: true,
    focusOnSelect: true,
    prevArrow: '.client-thumbnails .prev-arrow',
    nextArrow: '.client-thumbnails .next-arrow',
    vertical: true,
  };
  popthumbSlider = {
    infinite: false,
    speed: 300,
    slidesToShow: 5,
    slidesToScroll: 1,
    asNavFor: '.popimagepreview',
    dots: false,
    autoplay: false,
    draggable: true,
    focusOnSelect: true,
    vertical: false,
    arrows: false,
  };
  popimageSlider = {
    infinite: false,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    dots: false,
    autoplay: false,
    draggable: false,
    prevArrow: '.client-feedback .prev-arrow',
    nextArrow: '.client-feedback .next-arrow',
    asNavFor: '.popimgthumbs',
  };
  offerOption: OwlOptions = {
    // loop: true,
    autoWidth: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    dots: false,
    navSpeed: 700,
    margin: 14,
    navText: [
      `<img alt="left" src=${this.environment1}assets/images/c-arrow-left.svg>`,
      `<img alt="right" src=${this.environment1}assets/images/c-arrow-right.svg>`,
    ],
    responsive: {
      0: {
        items: 3,
      },
      400: {
        items: 3,
      },
      740: {
        items: 3,
      },
      1350: {
        items: 3,
      },
    },
    nav: true,
  };
  locationData: any;
  Pincode: any;

  codeDealer: any;
  dealIdData: any;
  checkPan: boolean = false;
  @ViewChild('panInput') panInput: ElementRef;
  address: any;
  cityList: any[];
  talukaList: any[];
  divisions: any[];
  financeDealerCode: any;
  emptyDealer: boolean = false;
  emptyDealerFni: boolean = false;
  dealername: any;
  encryptAdharNO: string;
  showBanner: boolean = false;
  vcdata = ['55272336100RVBD9', '55130852100RVDB2', '51374120BFDR', '55506735AFDR', '55508032AFDR', '51379920AFDR', '26423245100RVCC6']

  pinCodeByLatLong: any;
  constructor(
    private activatedRoute: ActivatedRoute,
    @Inject(PLATFORM_ID) private platformId: Object,
    private apiService: ApiService,
    private regexService: RegexService,
    private toastrService: ToastrService,
    private storageService: RootService,
    private spinner: NgxSpinnerService,
    private cleverService: ClevertapService,
    private formBuilder: FormBuilder,
    private formErrorService: FormErrorService,
    private CommonService: CommonService,
    private localStorage: secureStorage,
    private router: Router,private meta: Meta
  ) {
    this.meta.addTag({ name: 'robots', content: 'noindex, nofollow' });
    this.loadAPI = new Promise((resolve) => {
      this.regexService.loadScript();
      resolve(true);
    });
  }

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      try {
        this.cleverService.onPageView(this.pagetitle);
      } catch {}
    }
    // if (localStorage.getItem('dealercd')) {
    //   this.isDisabled = true;
    // }



    if (this.router.url.includes('payment_type=cc_avenue')) {
      this.activatedRoute.queryParams.subscribe((params) => {
         if (isPlatformBrowser(this.platformId)) {
        this.Payresponse = JSON.parse(this.localStorage.getItem('Payresponse'));
         }
        //  let order_id = params["order_id"];
        let success = params['success'];

        this.id = this.Payresponse.vehicleID;
        this.isLoading = true;
        this.defaultbannerImg =
          environment.s3bucket.url + 'ProductLead/' + 1520 + '.jpg';
        this.bannerImg =
          environment.s3bucket.url + 'ProductLead/' + this.id + '.jpg';
        this.bannerList = [
          {
            image: this.defaultbannerImg,
          },
        ];
        this.isLoading = true;
        this.getVehicleDetail();
        if (success == 'true') {
          this.showCongratulationMsg = true;
          this.tractionSuccess = true;
          // let Message =  this.Payresponse?.payMessage+
          // " received against Request ID " +
          // this.Payresponse?.reqId +
          // ".";
          this.reqID = this.Payresponse?.reqId;
           if (isPlatformBrowser(this.platformId)) {
          localStorage.removeItem('accessTokenSILead');
           }
        } else {
          this.showCongratulationMsg = true;

          this.tractionfailed = true;
          let Message =
            this.Payresponse?.payMessage +
            ' is not received against Request ID ' +
            this.Payresponse?.reqId +
            '.';
          this.Payresponse.headMessage = 'Sorry !';
          let HeadMessage = 'Sorry !';
          const ResponseDatas: PaymentResponse = {} as PaymentResponse;
          ResponseDatas.razorpay_order_id = this.Payresponse?.orderId;
          this.errormsg = {
            head: HeadMessage,
            desc: Message,
          };
           if (isPlatformBrowser(this.platformId)) {
          localStorage.removeItem('accessTokenSILead');
           }
        }
      });
    } else {
      this.activatedRoute.paramMap.subscribe((params) => {
        this.id = params.get('id');
        this.encData = params.get('reqid');
        this.orderID = params.get('orderID');
        this.activatedRoute.queryParams.subscribe((params) => {
          this.codeDealer = params['dealer'];
          if(this.codeDealer){

            this.getDealer()
          }
        })




        if (params.get('id')) {
          this.isLoading = true;
          this.defaultbannerImg =
            environment.s3bucket.url + 'ProductLead/' + 1520 + '.jpg';
          this.bannerImg =
            environment.s3bucket.url + 'ProductLead/' + this.id + '.jpg';
          this.bannerList = [
            {
              image: this.defaultbannerImg,
            },
          ];
          this.isLoading = true;
          this.getVehicleDetail();

          this.booking();
          this.requestNotificationPermission()
        }
      });
    }
    // this.isDisabled = true;
    this.campaign();
    this.getDealerDetail();
    this.getEncryptionccavenue();
  }

  public loadScript() {
    if (isPlatformBrowser(this.platformId)) {
      let node = document.createElement('script');
      node.src = url;
      node.type = 'text/javascript';
      node.async = true;
      node.charset = 'utf-8';
      document.getElementsByTagName('head')[0].appendChild(node);

      var noscript = document.createElement('noscript');
      var iframe = document.createElement('img');
      iframe.setAttribute(
        'src',
        'https://www.facebook.com/tr?id=848798723707544&ev=PageView&noscript=1'
      );
      iframe.setAttribute('height', '1');
      iframe.setAttribute('width', '1');
      iframe.setAttribute('style', 'display:none;');
      noscript.appendChild(iframe);
      document.body.appendChild(noscript);
    }
  }
  getcodeCT(eventName) {
    if (isPlatformBrowser(this.platformId)) {
      this.cleverService.GetCodeClicked(
        eventName,
        this.bookingForm.value.mobile,
        this.id,
        this.productDetailList?.model,
        window.location.href
      );
    }
  }

  getQuantity() {
    if (this.bookingForm.value.quantity == '0') {
      this.bookingForm.patchValue({
        quantity: '1',
      });
    }
  }
  getVehicleDetail() {
    let data;
    data = {
      product_id: this.id,
    };
    this.sub.add(
      this.apiService.getVehicleDetails(data).subscribe({
        next: (res: any) => {
          if (res.success) {
            this.productDetailList = res?.data;
            this.imageUrl = this.productDetailList?.images[0]?.image_url;
            if (this.vcdata.includes(this.productDetailList?.vehicle_number)) {
              this.showBanner = true;
                          }
            this.getOffer();
            this.getStateList(this.productDetailList.lob);
            this.totalAmount = this.productDetailList?.down_payment;
            this.productLoaded = true;
            this.getfinancer();
            if (isPlatformBrowser(this.platformId)) {
              this.cleverService.LandingPageViewed(
                this.id,
                this.productDetailList?.model,
                this.productDetailList?.images[0]?.image_url,
                this.productDetailList['sub_lob'],
                this.productDetailList['lob'],
                this.productDetailList['ppl'],
                window.location.href,
                this.productDetailList['price_range'],
                this.productDetailList['down_payment']
              );
            }
          }
        },
        error: () => {
          this.productLoaded = true;
          this.toastrService.success('Not Found');
        },
        complete: () => {
          this.getLeadDetail();
        },
      })
    );
  }

  booking(item?) {
    this.bookingForm = this.formBuilder.group({
      first_name: [
        item?.user?.first_name,
        [
          Validators.required
        ],
      ],
      last_name: [
        item?.user?.last_name
      ],
      state: [item ? item?.leads[0]?.state_code : '', [Validators.required]],
      district: [item ? item?.leads[0]?.district : '', [Validators.required]],
      dealer: [item ? item?.leads[0]?.division_id : '', [Validators.required]],
      quantity: 1,
      // quantity: [item?.leads[0]?.quantity, [Validators.required, Validators.maxLength(2), Validators.min(1), Validators.max(10)]],
      mobile: [
        '',
        [
          Validators.required,
          Validators.maxLength(10),
          Validators.pattern(this.regexService.Phone),
        ],
      ],
      other_financier: [item ? item?.leads[0]?.financier_name : '' ,[Validators.required]],
      panNo: ["", [Validators.required, Validators.pattern(this.regexService.Pan)]],
      aadhar: ["", [Validators.required, Validators.pattern(this.regexService.Aadhar)],
      ],
      address1: ["", [Validators.required]],
      address2: ["", [Validators.required]],
      pincode:["", [Validators.required]],
      email_id:["", [Validators.required,Validators.pattern(/^\w+([\.]?\w+)*@\w+([\.]?\w+)*(\.\w{2,3})+$/)],],
      taluka:["", [Validators.required]],
    city:["", [Validators.required]],
      otp: [''],
    });

    if (item) {
      let a = this.dealerList.filter(
        (element) => element.division_id == this.bookingForm.value.dealer

        // element.division_id == this.bookingForm.value.dealer
      );

      if (a?.[0]?.payment_details?.[0]?.payment_gt_type == 'CCAVENUE') {
        this.getCcAvenueEncryptionKey(
          this.LeadDetailList,
          a?.[0]?.payment_details?.[0]?.account_id,
          this.leadData.product
        );
      } else if (a?.[0]?.payment_details?.[0]?.payment_gt_type == 'RAZORPAY') {
        let orderDetails = {
          razorpay_account_id: this.leadData.razor_pay_detail[0].account_id,
          razorpay_access_key: this.leadData.razorpay_access_key,
          // razorpay_access_key: this.leadData.razor_pay_detail[0].access_key_id,
          order_id: this.orderID,
          pay_amount: this.leadData.product.down_payment,
          product_name: this.leadData.product.pl,
          product_description: this.leadData.product.vehicle_number,
          shopping_order_id: this.leadData.row_id,
          email: this.userData.email_id,
          contact: this.userData.mobile_number,
        };
        this.payMessage = 'Request In Process';
        // this.isVerifyOtp = true;
        this.payWithRazor(orderDetails, this.leadData, this.leadData.product);
      } else {
        this.toastrService.warning(
          'We are unable to find payment gateway account. Please contact TML on Toll Free Number 1800 209 7979 or cac@tatamotors.com for assistance.'
        );
      }
    }
  }
  getVCPrice(data) {
    this.sub.add(
      this.apiService.getDealerPrice(data).subscribe({
        next: (response: any) => {
          this.newVCPrice = response?.data?.dealer_price
            ? response.data.dealer_price
            : null;
        },
        error: () => {},
        complete: () => {},
      })
    );
  }
  setDivision() {
    this.divData = this.dealerList.filter(
      (division: any) => division.division_id == this.bookingForm.value.dealer
    );

    let priceData = {
      dealer_code: this.divData[0]?.dealer_code,
      vc_number: this.productDetailList['vehicle_number']
        ? this.productDetailList['vehicle_number']
        : '',
    };
    this.getVCPrice(priceData);
  }
  getStateList(lob: any) {
    this.stateList = [];

    lob = {
      lob: lob,
    };

    this.sub.add(
      this.apiService.getLocations(lob).subscribe({
        next: (response: any) => {
          if (response['success']) {
            this.stateList = response['data'];
            if (this.codeDealer && this.disableMainFields) {
              if (this.stateList?.length > 0) {
                this.getDealerDistricList(
                  this.dealIdData?.state_name,
                  this.dealIdData?.state
                );
              }
            }
          }
        },
        error: () => {},
        complete: () => {},
      })
    );
  }

  getDealerDealerList() {
    let data: any;
    data = {
      dealer_code: this.codeDealer,
      action_type: 'dropdown',
    };
    this.sub.add(
      this.apiService.getDealerList(data).subscribe({
        next: (response: any) => {
          if (response['success']) {
            let dealerData = response['data'];
            dealerData.forEach((e) => {
              const exists = this.dealerList.some(
                (dealer) => dealer?.division_name === e?.division_name
              );
              if (!exists) {
                this.dealerList.push({
                  division_id: e.division_id,
                  division_name: e.division_name,
                  state_name: e.state_name,
                  state: e.state,
                });
              }
            });
            this.bookingForm.patchValue({ state: this.dealerList?.[0].state });
            this.bookingForm.patchValue({
              dealer: this.dealerList?.[0]?.division_id,
            });
            this.bookingForm.patchValue({
              city: this.dealerList?.[0]?.city,
            }); this.bookingForm.patchValue({
              dealer: this.dealerList?.[0]?.division_id,
            });
          } else {
            this.toastrService.warning('Something went wrong!');
          }
        },
        error: (error) => {
          this.toastrService.warning(error.data.msg);
        },
        complete: () => {},
      })
    );
  }

  getDealerList(state?: any, state_cd?: any, district?: any) {
    this.resetForm('dealer');
    let ll;
    if (state && state_cd) {
      ll = {
        code: state_cd,
        state: state,
      };
    } else {
      this.statedata = this.stateList.filter(
        (result) => result.code === this.bookingForm.value.state
      );

      ll = {
        code: this.statedata[0]?.code,
        state: this.statedata[0]?.name,
      };
    }
    let data: any;

    data = {
      district: this.codeDealer && this.disableMainFields ? this.dealIdData?.district :  state && state_cd ? district : this.bookingForm.value.district,
      state: ll.code,
      vc: this.productDetailList.vehicle_number,
      lob_name: this.productDetailList.lob,
    };
    if (this.codeDealer && this.disableMainFields) {
      data['dealer_code'] = this.codeDealer;
    }
    this.sub.add(
      this.apiService.getDealerList(data).subscribe({
        next: (response: any) => {
          if (response['success']) {
            this.dealerList = response['data'];
            if (this.codeDealer) {
              this.bookingForm.patchValue({
                dealer: this.dealerList?.[0]?.division_id,
              });
              this.setDivision();
            } else {
              // this.toastrService.warning('Something went wrong!');
            }
          }

        },
        error: (error) => {
          this.toastrService.warning(error.data.msg);
        },
        complete: () => {
          if (this.encData) {
            this.booking(this.LeadDetailList);
          }
        },
      })
    );
  }
  requestNotificationPermission() {

    if (Notification.permission === 'default') {

      Notification.requestPermission().then((permission) => {
        if (permission === 'granted') {
          this.getUserLocation();
        } else if (permission === 'denied') {
          console.error('Notification permission denied.');
          // alert('Notifications are blocked. Please enable them in your browser settings to receive notifications.');
        }
      });
    } else if (Notification.permission === 'granted') {

      this.getUserLocation();
    } else if (Notification.permission === 'denied') {

      // alert('You have blocked notifications. Please enable them from your browser settings if you wish to receive notifications.');
    }
  }

  // Function to show notifications
  showNotification(title: string, body: string) {
    const options = {
      body,
      icon: 'assets/icon/location.png', // Optional icon
    };
    new Notification(title, options);
  }

  getUserLocation() {
    if (isPlatformBrowser(this.platformId)) {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const lat = position.coords.latitude;
          const lon = position.coords.longitude;
          const accuracy = position.coords.accuracy;

          this.showNotification('Location Access Granted', 'You allow us to access your location.');

          setTimeout(() => {
            this.sendLocationToApi(lat, lon);
          }, 2000);
        },
        (error) => {
          if (error.code === error.PERMISSION_DENIED) {
            if (isPlatformBrowser(this.platformId)) {
            const locationDeniedShown = localStorage.getItem('locationDeniedNotificationShown');
            if (!locationDeniedShown) {
              localStorage.setItem('locationDeniedNotificationShown', 'true');
              this.showNotification('Location Access Denied', 'You denied location access.');
            }
          }
          } else {
            console.error('Geolocation error:', error.message);
          }
        },
        {
          enableHighAccuracy: true,
          timeout: 10000,
          maximumAge: 0,
        }
      );
    } else {
      console.error('Geolocation is not supported by this browser.');
    }
  }
  }


  sendLocationToApi(latitude: number, longitude: number) {
    const payload = { latitude, longitude };
    try {
      this.sub.add(
        this.apiService.getPincodeBaseOnLatLong(payload).subscribe({
          next: (response: any) => {
            if(response.success){
              this.locationData = response?.data;
              this.Pincode = this.locationData?.pincode
              // localStorage.setItem("userPincode", this.locationData?.pincode);
              // localStorage.setItem('locationPermissionGranted', 'true');
              if (this.bookingForm) {
                this.bookingForm.patchValue({ pincode: this.Pincode });
                this.addressByPincode();
              }
            }
          },
          error: (error: any) => {
            console.error('Error sending location:', error);
          }
        })
      );
    } catch (err) {
      console.error('Unexpected error occurred:', err);
    }
  }


  signup() {
    if (this.bookingForm.status == 'INVALID') {
      this.formErrorService.displayFormErrors(this.bookingForm);

      return;
    }

    let data = {
      first_name: this.CommonService.replaceUnicode(
        this.bookingForm.value.first_name
      ),
      last_name: this.CommonService.replaceUnicode(
        this.bookingForm.value.last_name
      ),
      mobile_number: this.bookingForm.value.mobile,
      email_id: '',
      state: this.bookingForm.value.state,
      district: this.bookingForm.value.district,
    };
    this.spinner.show();
    this.sub.add(
      this.apiService.userSignup(data).subscribe({
        next: (response: any) => {
          if (response.success) {
            if (isPlatformBrowser(this.platformId)) {
              this.cleverService.CodeVerified(
                this.CommonService.replaceUnicode(data.first_name),
                this.CommonService.replaceUnicode(data.last_name),
                data.state,
                data.district,
                this.divData[0]?.division_id
                  ? this.divData[0]?.division_id
                  : '',
                String(this.bookingForm.value.quantity),
                data.mobile_number,
                this.id,
                this.productDetailList?.model,
                window.location.href
              );
              this.cleverService.onUserLogin(
                response.data.first_name + ' ' + response.data.last_name,
                response.data.email_id,
                response.data.mobile_number
              );
            }
            this.getCode('Get Code Clicked');
            this.spinner.hide();
          } else {
            this.toastrService.warning('Something went wrong!');
            this.spinner.hide();
          }
        },
        error: () => {
          this.toastrService.warning('Something went wrong!');
          this.spinner.hide();
        },
        complete: () => {
          this.spinner.hide();
        },
      })
    );
  }

  getDealerDistricList(stateName, stateCode) {
    if (this.bookingForm.value.pincode?.length == 6) {
      this.getAddress(this.bookingForm.value.pincode);
    }
    this.statedata = this.stateList.filter(
      (result) => result.code === this.bookingForm.value.state
    );
    let data = {
      state: { code: stateCode, state: stateName },
      lob: this.productDetailList.lob,
      dealer_code: this.codeDealer && this.disableMainFields ? this.codeDealer : '',
    };
    this.sub.add(
      this.apiService.getLocations(data).subscribe({
        next: (response: any) => {
          if (response['success']) {
            this.districtList = response['data'];
            this.bookingForm.patchValue({ district: this.districtList?.[0] });
          }
          this.getDealerList(stateName, stateCode, this.districtList?.[0]);
        },
        error: () => {},
        complete: () => {},
      })
    );
  }

  async getDistrictList(state?: any, state_cd?: any) {
    this.dealerList = [];
    this.districtList = [];
    this.resetForm('district');
    this.resetForm('dealer');

    let ll;
    if (state && state_cd) {
      ll = {
        code: state_cd,
        state: state,
      };
    } else {
      this.statedata = this.stateList?.filter(
        (result) => result.code === this.bookingForm.value?.state
      );

      if (!this.statedata?.length) {
        console.error('State data is invalid or not found');
        return;
      }

      ll = {
        code: this.statedata[0]?.code,
        state: this.statedata[0]?.name,
      };
    }

    const stateData = {
      state: ll,
      lob: this.productDetailList?.lob,
    };

    try {
      const response = await this.apiService.getLocations(stateData).toPromise();
      if (response?.success) {
        this.districtList = response.data || [];
      } else {
        console.warn('Failed to fetch district list');
      }
    } catch (error) {
      console.error('Error fetching district list:', error);
    }
  }

  alphanumbericOnlyFirstLastName(event: any): boolean {
    var inp = String.fromCharCode(event.keyCode);
    if (/[a-zA-Z]|[.]|[ ]/.test(inp)) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }
  NumberKeyEvent(event: any) {
    var ASCIICode = event.which ? event.which : event.keyCode;
    if (ASCIICode > 31 && (ASCIICode < 48 || ASCIICode > 57)) return false;
    return true;
  }
  // onFocusOutRemoveSpaceFirstName(event: any) {
  //   let value = (event.target.value).replace(/\s/g, "")
  //   this.bookingForm.patchValue({ first_name: value })
  // }


  onlyNumberKey(event: any) {
    return this.regexService.NumberKeyEvent(event);
  }
  notAllowSpace(event: any) {
    if ((event.target.selectionStart === 0 && event.which === 32) || event.key === '.') {
      event.preventDefault();
    }
  }

  campaign() {
    this.activatedRoute.queryParams.subscribe(async (params: any) => {
      this.utm_source = await params['utm_source'];
      this.utm_medium = await params['utm_medium'];
      this.utm_campaign =
        (await params['utm_campaign']) || (await params['utm_campaignname']);
      this.gclid = await params['gclid'];
    });
  }

  getDealerDetail() {
    this.activatedRoute.queryParams.subscribe(async (params: any) => {
      this.dealerCode = await params['dealer_code'];
      if (this.dealerCode) {
        this.getDealerDealerList();
      }
    });
  }

  getCode(evntName) {
    this.isSubmitted = true;
    this.getcodeCT(evntName);

    if (this.bookingForm.invalid) {

      const controls = this.bookingForm.controls;

      const firstInvalidRequiredControl = Object.keys(controls).find((key) => {
        const control = controls[key];
        return (
          control.hasValidator(Validators.required) &&
          control.invalid
        );
      });

      if (firstInvalidRequiredControl) {
        const invalidElement = document.getElementsByName(firstInvalidRequiredControl)[0]; // Use name attribute
        if (invalidElement) {
          invalidElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
          (invalidElement as HTMLElement).focus();
        }
      }
    }
    if (this.bookingForm.status === 'INVALID') {
      this.formErrorService.displayFormErrors(this.bookingForm);
      return;
    }
    // if (
    //   this.regexService.containsSpecialChars(
    //     this.bookingForm.value.last_name.trim() ||
    //       this.bookingForm.value.first_name.trim()
    //   )
    // ) {
    //   this.toastrService.warning('Special characters are not allowed');
    //   return;
    // }
    this.spinner.show();
    let data = {
      mobile_number: this.bookingForm.value.mobile,
      action_type: 'login',
    };
    this.sub.add(
      this.apiService.sentOtp(data).subscribe({
        next: (response: any) => {
          if (response.success) {
            //getcode ct event
            this.getcodeCT('Code Sent Successfully');
            this.startTimer(119);

            this.showotp = true;
            this.disabledFields = true;
            this.toastrService.success(response.data.msg);
            this.spinner.hide();
          } else {
            this.spinner.hide();
            if (response?.data?.msg == 'User is not registered.') {
              this.signup();
            } else {
              this.toastrService.warning('Something went wrong!');
              this.spinner.hide();
            }
          }
        },
        error: () => {
          this.toastrService.warning('Something went wrong!');
          this.spinner.hide();
        },
        complete: () => {
          this.spinner.hide();
        },
      })
    );
  }

  async createLead() {
    let useradhar = this.bookingForm.value.aadhar ? this.bookingForm.value.aadhar :"";
    if (isPlatformBrowser(this.platformId)) {
      this.encryptAdharNO = this.localStorage.encryptData(useradhar);
    }
    this.spinner.show();
    let data = {
      lead_type: 'FINANCE',
      mm_geography: this.codeDealer && this.disableMainFields ? this.dealIdData?.mm_geography : this.divData?.[0]?.mm_geography
        ? this.divData?.[0]?.mm_geography
        : '',
      division_id: this.codeDealer && this.disableMainFields ? this.dealIdData?.division_id :  this.divData?.[0]?.division_id
        ? this.divData?.[0]?.division_id
        : '',
      lob: this.productDetailList?.lob ? this.productDetailList?.lob : '',
      mobile_number: this.bookingForm.controls['mobile'].value,
      first_name: this.CommonService.replaceUnicode(
        this.bookingForm.controls['first_name'].value.trim()
      ),
      last_name: this.bookingForm.controls['last_name'].value
        ? this.CommonService.replaceUnicode(
            this.bookingForm.controls['last_name'].value
          )
        : '.',
      address_one: this.bookingForm.controls['address1'].value,
      address_two: this.bookingForm.controls['address2'].value,
      state: this.codeDealer && this.disableMainFields ? this.dealIdData?.state_name :  this.statedata?.[0]?.name,
      state_code:this.codeDealer && this.disableMainFields ? this.dealIdData?.state : this.statedata?.[0]?.code,
      district:this.codeDealer && this.disableMainFields ? this.dealIdData?.district : this.bookingForm.value.district,
      // organization_name:
        // this.productDetailList.lob == "HCV Cargo" || this.productDetailList.lob == "MCV Trucks" || this.productDetailList.lob == "HCV Const" || this.productDetailList.lob == "ICV Trucks"?
        // this.CommonService.replaceUnicode(
        //   this.bookingForm.controls['first_name'].value.trim()
        // ) +
        // this.CommonService.replaceUnicode(
        //   this.bookingForm.controls['last_name'].value
        // ) +
        // this.bookingForm.controls['mobile'].value,
        organization_name:
        this.CommonService.replaceUnicode(this.bookingForm.controls['first_name'].value.trim()) +
        (this.bookingForm.controls['last_name'].value?.trim() ? this.CommonService.replaceUnicode(this.bookingForm.controls['last_name'].value.trim()) : '') +
        this.bookingForm.controls['mobile'].value,
      // : ""
      pincode: this.bookingForm.controls['pincode'].value,
      email_id: this.bookingForm.controls['email_id'].value,
      vehicle_application: 'NA',
      body_type: 'NA',
      usage_category: '',
      vc_description: this.productDetailList['product_description']
        ? this.productDetailList['product_description']
        : '',
      vc_number: this.productDetailList['vehicle_number']
        ? this.productDetailList['vehicle_number']
        : '',
      ppl: this.productDetailList['ppl'] ? this.productDetailList['ppl'] : '',
      vc_id: this.productDetailList['vehicle_id']
        ? this.productDetailList['vehicle_id']
        : '',
      pl: this.productDetailList['pl'] ? this.productDetailList['pl'] : '',
      // "quantity": String(this.bookingForm.value.quantity),
      quantity: String(this.bookingForm.value.quantity),
      model: this.productDetailList['model']
        ? this.productDetailList['model']
        : '',
      interested_in_exchange: 'No',
      brand: '',
      registration_number: '',
      pi_for_exchange: '',
      chassis_number: '',
      manufacture_year: '',
      mileage: '',
      action_type:
        this.divData?.[0]?.payment_details?.length == 0 ? 'Unbilled' : 'Billed',
      down_payment: this.productDetailList['down_payment'],
      payment_gateway_type:
        this.divData?.[0]?.payment_details?.length > 0
          ? this.divData?.[0]?.payment_details[0]?.payment_gt_type
          : 'RAZORPAY',
      channel: 'Fleet Verse',
      finance_account_id: '1-39ERX-657',
      finance: 'SELF',
      source: this.utm_source,
      medium: this.utm_medium,
      campaign: this.utm_campaign,
      campaign_id: this.gclid,
      lead_origin: 'Finance Landing Page',
      taluka:this.bookingForm.controls['taluka'].value,
      city: this.bookingForm.controls['city'].value,
      ex_showroom_price: Math.round(this.newVCPrice),
      other_financier: this.bookingForm.controls['other_financier'].value,
      pan_no: this.bookingForm.controls['panNo'].value,
      aadhar_number:this.encryptAdharNO
      // pan_no: this.localStorage.encryptData((String(this.bookingForm.controls['panNo'].value))),
      // aadhar_number:this.localStorage.encryptData((String(this.bookingForm.controls['aadhar'].value)))
    };
    if (data.organization_name?.length > 50) {
      data['organization_name'] =
        this.CommonService.replaceUnicode(
          this.bookingForm.controls['first_name'].value.trim()
        ).trim() + this.bookingForm.value.mobile;
    }
    if (data.organization_name?.length > 50) {
      data['organization_name'] =
        this.CommonService.replaceUnicode(
          this.bookingForm.controls['last_name'].value
        ).substring(0, 39) + this.bookingForm.value.mobile;
    }
    await this.sub.add(
      this.apiService.generateLead(data).subscribe({
        next: (response: any) => {
          if (response['success']) {
            this.reqID = response.data.lead_row_id;
            if (this.reqID) {
             this.offertrue = true
            }
            if (isPlatformBrowser(this.platformId)) {
              var unxPayload = [
                {
                  pid: this.productDetailList.vehicle_number.toString(),
                  variantId: this.productDetailList.vehicle_number, // Only if variant is present
                  qty: String(this.bookingForm.value.quantity),
                  price: this.productDetailList.price_range.toString(),
                },
              ];

              unbxUrl.fireUnbxdOrder(unxPayload);

              this.cleverService.FormSubmitted(
                'Form Submitted',
                data.state,
                data.district,
                data.division_id,
                data.quantity,
                this.productDetailList?.images[0]?.image_url,
                this.id,
                this.productDetailList?.model,
                window.location.href,
                this.productDetailList['sub_lob'],
                this.productDetailList['lob'],
                this.productDetailList['ppl'],
                this.productDetailList['price_range'],
                this.productDetailList['down_payment']
              );
            }
            this.showCongratulationMsg = true;

            this.response = response.data;
            this.toastrService.success(response.data.msg);
            this.tractionSuccess = true;
            this.spinner.hide();
          } else {
            if (isPlatformBrowser(this.platformId)) {
              this.cleverService.FormSubmitted(
                'Form Submission Failed',
                data.state,
                data.district,
                data.division_id,
                data.quantity,
                this.productDetailList?.images[0]?.image_url,
                this.id,
                this.productDetailList?.model,
                window.location.href,
                this.productDetailList['sub_lob'],
                this.productDetailList['lob'],
                this.productDetailList['ppl'],
                this.productDetailList['price_range'],
                this.productDetailList['down_payment']
              );
            }
            this.showCongratulationMsg = true;

            this.tractionfailed = true;

            this.spinner.hide();
            if (
              response.data.msg ==
              'Oops! You already have active request against this vehicle. Please visit My Booking Request section in Profile to complete the process.'
            ) {
              this.errormsg = {
                head: 'Duplicate Request',
                desc: 'Oops! You already have active request against this vehicle.',
              };
            } else {
              this.errormsg = {
                head: 'Request Failed',
                desc: response.data.msg,
              };
            }
            // this.toastrService.warning(response.data.msg);
          }
        },
        error: () => {
          this.spinner.hide();
        },
        complete: () => {
          this.spinner.hide();
        },
      })
    );
  }

  getNumber() {
    this.showotp = false;
  }

  verify() {
    this.spinner.show();
    if (
      this.bookingForm.value.otp?.length == 0 ||
      this.bookingForm.value.otp?.length < 6
    ) {
      this.spinner.hide();

      this.toastrService.warning('Please enter OTP');
      return;
    }
    this.hideproceedbtn = true;
    let data = {
      mobile_number: this.bookingForm.value.mobile,
      otp_number: this.bookingForm.value.otp,
    };
    this.spinner.show();
    this.sub.add(
      this.apiService.userLogin(data).subscribe({
        next: (response: any) => {
          if (response.success) {
            this.storageService.loginUser(response.data);
            this.spinner.show();
            this.createLead();
          } else {
            this.toastrService.warning(response.data.msg);
            this.spinner.hide();
            this.hideproceedbtn = false;
          }
        },
        error: () => {
          this.hideproceedbtn = false;
          this.spinner.hide();
          this.toastrService.warning(
            'Your account is locked due to multiple incorrect OTP. Please try after sometime'
          );
        },
        complete: () => {},
      })
    );
  }

  resetForm(value: any) {
    this.bookingForm.controls[value]?.setValue('');
    this.bookingForm.get(value)?.updateValueAndValidity();
  }

  startTimer(timeLeft: any) {
    this.timeLeft = timeLeft;
    const interval = setInterval(() => {
      this.isTimer = true;
      this.m = Math.floor(this.timeLeft / 60);
      this.s = this.timeLeft % 60;
      this.m = this.m < 10 ? '0' + this.m : this.m;
      this.s = this.s < 10 ? '0' + this.s : this.s;
      this.timeLeft--;
      if (this.timeLeft < 0) {
        this.isTimer = false;
        this.disabledFields = false;
        clearInterval(interval);
      }
    }, 1000);
  }

  getLeadDetail() {
    let data;
    data = {
      // request_id: this.encData.row_id
      request_id: this.encData,
    };
    this.sub.add(
      this.apiService.getLeadsbyrefid(data).subscribe({
        next: (res: any) => {
          if (res.success) {
            this.LeadDetailList = res?.data;
            if (isPlatformBrowser(this.platformId)) {
            this.localStorage.setItem(
              'accessTokenSILead',
              JSON.stringify(res?.data.user.token.token.access_token)
            );
          }
            this.leadData = this.LeadDetailList?.leads[0];
            this.userData = this.LeadDetailList?.user;
            let vehicleData = this.LeadDetailList?.leads[0].vehicle_info;

            let image = vehicleData['images']
              ? vehicleData['images']
              : vehicleData['image']
              ? vehicleData['image']
              : vehicleData['images'];
            if (image) {
              if (image?.image_url) {
                this.imageUrl = image.image_url;
              } else {
                image
                  .filter((image1: any) => image1.is_cover === true)
                  .map((img: any) => {
                    this.imageUrl = img['image_url'];
                  });
              }
            }
          }
        },
        error: () => {
          this.toastrService.success('Lead is not found');
        },
        complete: () => {
          if (this.encData) {
            this.getDistrictList(
              this.LeadDetailList?.leads[0]?.state,
              this.LeadDetailList?.leads[0]?.state_code
            );
            this.getDealerList(
              this.LeadDetailList?.leads[0]?.state,
              this.LeadDetailList?.leads[0]?.state_code,
              this.LeadDetailList?.leads[0]?.district
            );
          }
        },
      })
    );
  }

  payWithRazor(orderDetails: any, leadInfo: any, vehicleData: any) {
    const ResponseData: PaymentResponse = {} as PaymentResponse;
    const options: any = {
      key: orderDetails.razorpay_access_key,
      amount: orderDetails.pay_amount,
      currency: 'INR',
      name: orderDetails.product_name, //'VSS', // company name or product name
      description: orderDetails?.product_description
        ? orderDetails?.product_description
        : '', //'Star City Bus',  // product description
      image: 'assets/images/tata-logo.png', // company logo or product image
      order_id: orderDetails.order_id, // order_id created by you in backend
      account_id: orderDetails.razorpay_account_id,
      prefill: {
        email: orderDetails.email,
        contact: orderDetails.contact,
      },
      modal: {
        escape: false,
      },
      notes: {
        shopping_order_id: orderDetails.shopping_order_id,
      },
      theme: {
        color: '#0c238a',
      },
    };
    options.handler = (response: any) => {
      this.payMessage =
        'Your payment of ₹' +
        orderDetails.pay_amount
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ',') +
        '/- received against Request ID ' +
        orderDetails.shopping_order_id +
        '.';
      options.response = response;
      ResponseData.razorpay_payment_id = response.razorpay_payment_id;
      ResponseData.razorpay_order_id = response.razorpay_order_id;
      ResponseData.razorpay_signature = response.razorpay_signature;
      this.sub.add(
        this.apiService.getPaymentDetail(ResponseData).subscribe({
          next: (response: any) => {
            if (response.success) {
              this.reqID = response.data.lead_row_id;

              const objthank: ThankuResponse = {} as ThankuResponse;
              objthank.headMessage = 'Thank You !';
              objthank.payMessage = this.payMessage;
              objthank.Image = this.imageUrl;
              objthank.vehicleID = vehicleData['id']
                ? vehicleData['id']
                : vehicleData['product_id']
                ? vehicleData['product_id']
                : vehicleData['id'];
              objthank.vehicleModel = vehicleData['model'];
              // objthank.orderAmount = response["data"].payment_amount / 100
              objthank.leadInfo = leadInfo;

              objthank.orderId = this.orderID;
              objthank.reqId = leadInfo.row_id;
              objthank.transactionStatus = 'success';
              if (isPlatformBrowser(this.platformId)) {
                objthank.productUrl = window.location.href;
              
              objthank.payment_gateway = 'RAZORPAY';
 if (isPlatformBrowser(this.platformId)) {
              this.localStorage.setItem(
                'Payresponse',
                JSON.stringify(objthank)
              );
            }
            }
              this.clevertapPayementcompFailed(
                leadInfo.booking_amount,
                leadInfo.quantity
              );

              this.showCongratulationMsg = true;

              this.tractionSuccess = true;
if (isPlatformBrowser(this.platformId)) {
              localStorage.removeItem('accessTokenSILead');
}
            } else {
              this.payMessage =
                'Your payment against Request ID ' +
                orderDetails.shopping_order_id +
                ' of ₹' +
                orderDetails.pay_amount
                  .toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ',') +
                '/- is not received.';
              this.clevertapPayementFailed(
                leadInfo.booking_amount,
                leadInfo.quantity
              );
              // this.transactionfailed = true;
              this.errormsg = {
                head: 'Sorry !',
                desc: this.payMessage,
              };
              this.showCongratulationMsg = true;
              this.tractionfailed = true;
              if (isPlatformBrowser(this.platformId)) {
              localStorage.removeItem('accessTokenSILead');
              }
            }
          },
          error: () => {},
          complete: () => {},
        })
      );
    };
    options.modal.ondismiss = () => {
      this.payMessage =
        'Your payment against Request ID ' +
        orderDetails.shopping_order_id +
        ' of ₹' +
        orderDetails.pay_amount
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ',') +
        '/- is not received.';
      // this.isVerifyOtp = true;
      const objthank: ThankuResponse = {} as ThankuResponse;
      objthank.headMessage = 'Sorry !';
      objthank.payMessage = this.payMessage;
      objthank.Image = this.imageUrl;
      objthank.vehicleID = vehicleData['id'];
      objthank.leadInfo = leadInfo;
      objthank.reqId = leadInfo.row_id;
      objthank.vehicleModel = vehicleData['model'];
      // objthank.orderAmount = orderDetails.payment_amount / 100;
      objthank.payment_gateway = 'RAZORPAY';
if (isPlatformBrowser(this.platformId)) {
      this.localStorage.setItem('Payresponse', JSON.stringify(objthank));
}
      const ResponseDatas: PaymentResponse = {} as PaymentResponse;
      ResponseDatas.razorpay_order_id = orderDetails.order_id;
      this.sub.add(
        this.apiService.getPaymentCancelDetail(ResponseDatas).subscribe({
          next: (response: any) => {
            if (response.success) {
              this.errormsg = {
                head: 'Sorry !',
                desc: this.payMessage,
              };
              this.showCongratulationMsg = true;
              this.tractionfailed = true;
              if (isPlatformBrowser(this.platformId)) {
              localStorage.removeItem('accessTokenSILead');
              }
            } else {
              this.clevertapPayementFailed(
                leadInfo.booking_amount,
                leadInfo.quantity
              );
              this.errormsg = {
                head: 'Sorry !',
                desc: this.payMessage,
              };
              this.showCongratulationMsg = true;

              this.tractionfailed = true;
              if (isPlatformBrowser(this.platformId)) {
              localStorage.removeItem('accessTokenSILead');
              }
            }
          },
        })
      );
    };
     if (isPlatformBrowser(this.platformId)) {
    const rzp = new this.nativeWindow.Razorpay(options);
    rzp.open();
     }
    return ResponseData;
  }
  get nativeWindow(): any {
    if (isPlatformBrowser(this.platformId)) {
      return _window();
    }
  }
  formatMoney(amount: any, decimalCount = 2, decimal = '.', thousands = ',') {
    // if (isPlatformBrowser(this.platformId)) {
    try {
      let i: any;
      decimalCount = Math.abs(decimalCount);
      decimalCount = isNaN(decimalCount) ? 2 : decimalCount;
      const negativeSign = amount < 0 ? '-' : '';
      i = parseInt(
        (amount = Math.abs(Number(amount) || 0).toFixed(decimalCount))
      ).toString();
      let j = i?.length > 3 ? i?.length % 3 : 0;
      return (
        negativeSign +
        (j ? i.substr(0, j) + thousands : '') +
        i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + thousands) +
        (decimalCount
          ? decimal +
            Math.abs(amount - i)
              .toFixed(decimalCount)
              .slice(2)
          : '')
      );
    } catch (e) {}
    // }
  }
  clevertapPayementcompFailed(amount, quantity) {
    if (isPlatformBrowser(this.platformId)) {
      try {
        this.cleverService.onPaymentCompleted(
          'Success',
          'Online Transfer',
          this.productDetailList['id'],
          this.productDetailList['model'],
          this.imageUrl,
          'Top Navigation',
          this.productDetailList['sub_lob'],
          this.productDetailList['lob'],
          this.productDetailList['ppl'],
          this.productDetailList['price_range']
            ? this.productDetailList['price_range']
            : '',
          this.productDetailList['down_payment'],
          amount * quantity
        );
      } catch {}
    }
  }
  clevertapPayementFailed(amount, quantity) {
    if (isPlatformBrowser(this.platformId)) {
      try {
        this.cleverService.onPaymentfailed(
          this.productDetailList['id'],
          'Online Transfer',
          this.imageUrl,
          this.productDetailList['model'],
          'Top Navigation',
          this.productDetailList['sub_lob'],
          this.productDetailList['lob'],
          this.productDetailList['ppl'],
          this.productDetailList['price_range']
            ? this.productDetailList['price_range']
            : '',
          this.productDetailList['down_payment'],
          amount * quantity
        );
      } catch {}
    }
  }

  payWithCcavenu(formGroup: FormGroup) {
    const myform = document.createElement('form');
    myform.method = 'POST';
    myform.action = this.ccavenue.baseurl;
    let input: any;
    for (const [key, value] of Object.entries(formGroup.value)) {
      input = document.createElement('input');
      input.name = key;
      input.id = key;
      input.value = value;
      myform.appendChild(input);
    }
    myform.style.display = 'none';
    myform.append('Content-Type', 'application/x-www-form-urlencoded');
    myform.append(
      'Accept',
      'text/html,application/xhtml+xml,application/xml;q=0.9,image/webp,image/apng,*/*;q=0.8'
    );
    document.body.appendChild(myform);
    myform.submit();
  }

  getEncryptionccavenue() {
    let req = {
      type: 'ccavenue',
      filter: environment.ccavenueType,
    };
    try {
      this.sub.add(
        this.apiService.getCCEncDetail(req).subscribe({
          next: (res: any) => {
            if (res.success) {
              if (isPlatformBrowser(this.platformId)) {
                let decrypt = this.localStorage.decryptData(res.data);
                this.ccavenue = JSON.parse(decrypt.replaceAll(`'`, `"`));
              }
            }
          },
          error: () => {},
          complete: () => {},
        })
      );
    } catch (error) {}
  }

  getCcAvenueEncryptionKey(leadInfo: any, ccavenueDetail, vehicleData) {
    let subAccId: string = '';
    subAccId = ccavenueDetail;

    let finalAmount =
      leadInfo.leads[0].vehicle_info.down_payment * leadInfo.leads[0].quantity;
    finalAmount = Number(finalAmount);

    let data = {
      data: {
        amount: Number(finalAmount),
        billing_address: '',
        billing_city: '',
        billing_email: '',
        billing_country: 'India',
        billing_name:
          this.CommonService.replaceUnicode(leadInfo?.user?.first_name) +
          ' ' +
          this.CommonService.replaceUnicode(leadInfo?.user?.last_name),
        billing_state: leadInfo?.user?.state,
        billing_tel: leadInfo?.user?.mobile_number,
        billing_zip: '',
        cancel_url: this.ccavenue.redirectURL,
        currency: 'INR',
        customer_identifier: '',
        delivery_address: '',
        delivery_city: '',
        delivery_country: 'India',
        delivery_name:
          this.CommonService.replaceUnicode(leadInfo?.user?.first_name) +
          ' ' +
          this.CommonService.replaceUnicode(leadInfo?.user?.last_name),
        delivery_state: leadInfo?.user?.state,
        delivery_tel: leadInfo?.user?.mobile_number,
        delivery_zip: '',
        language: 'EN',
        merchant_id: this.ccavenue.merchant_id,
        order_id: leadInfo.leads[0].payment_info.razorpay_order_id,
        promo_code: '',
        // "sub_account_id":subAccId,
        merchant_param1: 'micro_lead',
        redirect_url: this.ccavenue.redirectURL,
      },

      working_key: this.ccavenue.workingKey,
    };

    data.data['sub_account_id'] = subAccId;

    this.payMessage =
      'Your payment of ₹' + this.formatMoney(finalAmount) + '/-';
    const objthank: ThankuResponse = {} as ThankuResponse;
    objthank.headMessage = 'Thank You !';
    objthank.payMessage = this.payMessage;
    objthank.Image = this.imageUrl;
    // objthank.orderId = response["data"].payment_order_id;
    objthank.orderId = this.orderID;

    objthank.leadInfo = leadInfo;
    objthank.reqId = leadInfo.leads[0].row_id;
    objthank.vehicleID = vehicleData['id']
      ? vehicleData['id']
      : vehicleData['product_id']
      ? vehicleData['product_id']
      : vehicleData['id'];

    objthank.vehicleModel = vehicleData['model'];
    objthank.orderAmount = finalAmount;
    if (isPlatformBrowser(this.platformId)) {
      objthank.productUrl = window.location.href;
    
    // objthank.payment_gateway = orderDetails["payment_gateway_type"]
    objthank.payment_gateway = 'CCAVENUE';
     if (isPlatformBrowser(this.platformId)) {
    this.localStorage.setItem('Payresponse', JSON.stringify(objthank));
     }
    }
    this.sub.add(
      this.apiService.getCCEncTokenDetail(data).subscribe({
        next: (res: any) => {
          if (res.success) {
            let encRequest = res.data;
            let ccavenuForm: FormGroup = this.formBuilder.group({
              encRequest: [encRequest],
              access_code: [this.ccavenue.accessCode],
            });
            this.payWithCcavenu(ccavenuForm);
          } else {
            this.toastrService.warning('Payment Aborted');
          }
        },
      })
    );
  }
  public hasRequiredError = (controlName: string): boolean | undefined =>
    this.formErrorService.hasRequiredError(controlName, this.bookingForm);
  public hasPatternError = (controlName: string): boolean | undefined =>
    this.formErrorService.hasPatternError(controlName, this.bookingForm);
  public hasMaxLengthError = (controlName: string): boolean | undefined =>
    this.formErrorService.hasPatternError(controlName, this.bookingForm);

  public hasMinLengthError = (controlName: string): boolean | undefined =>
    this.formErrorService.hasPatternError(controlName, this.bookingForm);

  get f(): { [key: string]: AbstractControl } {
    return this.bookingForm.controls;
  }

  addressByPincode() {
    this.stateList = [];
    this.districtList = [];
    this.cityList = [];
    this.talukaList = [];
    this.bookingForm.patchValue({ "state": "", "district": "", "city": "", "taluka": "" });
    if (this.bookingForm.value.pincode?.length == 6) {
      this.getAddress(this.bookingForm.value.pincode);
      this.onChangeDistrict()
    }
  }

  getAddress(pincode: string | number) {
    const data = {
      pincode: pincode,
      app_name: "com.tatamotors.cvonline",
      device_id: "1234"
    };

    this.sub.add(
      this.apiService.getAddressByPincodeList(data).subscribe({
        next: (response: any) => {
          // If the response has results
          if (response?.length) {
            this.address = response;
            this.talukaList = Array.from(new Set(this.address.map((obj: any) => obj.taluka)));
            this.stateList = [response[0]?.state]; // Using an array for state
            this.districtList = [response[0]?.district?.toLowerCase()]; // Using an array for district
  this.cityList =[response[0]?.city];
            // Automatically select the first taluka
            this.onTalukaSelect(this.talukaList[0]);

            // Update the form with the relevant data
            this.bookingForm.patchValue({
              district: this.districtList[0],
              state: this.stateList[0]?.code || "", // Ensure state code is used if available
              taluka: this.talukaList[0],
              city: this.cityList[0]
            });

            // Fetch dealer list and reset the form as needed
            this.getDealerList();
            this.resetForm('dse');
          } else {
            // Show warning if no results found
            this.toastrService.warning('Address not found for pincode provided');

            // Reset form fields
            this.bookingForm.patchValue({
              district: "",
              state: "",
              city: "",
              taluka: ""
            });

            // Trigger state list fetch
            this.getStateList(this.productDetailList.lob);
          }
        },
        error: (err) => {
          // Log and handle errors here
          console.error('Error fetching address:', err);
          this.toastrService.error('Failed to fetch address data, please try again later.');
        }
      })
    );
  }

  async onChangeDistrict() {
    this.divData = [];
    this.divisions = [];
    if (
      this.bookingForm.get("district").valid &&
      this.bookingForm.get("state").valid
    ) {

      let data = {
        district: String(this.bookingForm.get("district").value),
        state: this.bookingForm.get("state").value,
        lob_name: this.productDetailList.lob ? this.productDetailList.lob : "",
        vc: this.productDetailList.vehicle_number
      };
      this.sub.add(this.apiService.getDealerList(data).subscribe({
        next: (response: any) => {
          if (response.success) {
            if (this.codeDealer) {
              this.divisions = [];
              response["data"].forEach((res) => { this.divisions.push(res); });
              let final = [];
               // if( this.financeDealerCode?.length > 0){
                this.divisions.forEach(element => {
                  if (this.codeDealer == element.dealer_code) {
                    this.financeDealerCode = final.push(element);
                  }
                  // });
                });
                if (final?.length == 0 && this.emptyDealer && this.financeDealerCode?.length > 0) {
                  this.divisions = final;
                  this.resetForm('division_id');
                  this.toastrService.error('Provided dealer do not serve in this area ');
                  return;
                }
                if (final?.length == 0 && !this.emptyDealer) {
                  this.divisions = final;
                  this.resetForm('division_id');
                  this.toastrService.error('Provided dealer do not serve in this area ');
                  return;
                }
                if (final?.length > 0) {
                  this.divisions = final;
                  if (final?.length == 1 && this.codeDealer) {
                    this.bookingForm.patchValue({
                      division_id: this.divisions[0]?.division_id,
                    })
                  }
                  this.setDivision();
                }
            }
            else{
              this.divisions = [];
              response["data"].forEach((res) => { this.divisions.push(res); });
              let final = [];
              if (response["data"]?.length == 1 && this.dealerCode) {
                this.bookingForm.patchValue({
                  division_id: this.divisions[0]?.division_id,
                })
                this.setDivision();
              }


              if (this.dealerCode) {
                // if( this.financeDealerCode?.length > 0){
                this.divisions.forEach(element => {
                  if (this.dealerCode == element.dealer_code) {
                    this.financeDealerCode = final.push(element);
                  }
                  // });
                });
                if (final?.length == 0 && this.emptyDealerFni && this.financeDealerCode?.length > 0) {
                  this.divisions = final;
                  this.resetForm('division_id');
                  this.toastrService.error('Provided dealer do not serve in this area ');
                  return;
                }
                if (final?.length == 0 && !this.emptyDealerFni) {
                  this.divisions = final;
                  this.resetForm('division_id');
                  this.toastrService.error(this.dealername[0].division_name +' do not serve in this area ');
                  return;
                }
                if (final?.length > 0) {
                  this.divisions = final;
                  if (final?.length == 1 && this.dealerCode) {
                    this.bookingForm.patchValue({
                      division_id: this.divisions[0]?.division_id,
                    })
                  }
                  this.setDivision();
                }
                // }
                else {
                }
              }
              else {
                this.setDivision();
              }
            }

          }
          else {
            this.toastrService.warning(response?.data?.msg);

          }
        }
      }));

    } else {
      this.divisions = [];
    }
  }

  onTalukaSelect(val) {
    this.cityList = []
    for (let i = 0; i < this.address?.length; i++) {
      if (val == this.address[i].taluka) {
        this.cityList.push(this.address[i].city)
      }
    }
  }


  getOffer() {
    let data = {
      noOfCampaignOffers: 10,
      lob: this.productDetailList.lob ? this.productDetailList.lob : '',
      ppl: this.productDetailList.ppl ? this.productDetailList.ppl : '',
      pl: this.productDetailList.pl ? this.productDetailList.pl : '',
      state: this.userData?.state ? this.userData?.state : '',
      sortBy: 'campaignSchemePriority',
      sortOrder: 'asc',
      offset: 0,
    };
    this.sub.add(
      this.apiService.getOffersDetailsNew(data).subscribe({
        next: (res: any) => {
          const hdbofferData = res.offers.filter((offer) => offer?.financierDetails?.crmFinancierName === "HDFC BANK LTD." || offer?.financierDetails?.crmFinancierName === 'HDB FINANCIAL SERVICES LIMITED' ||  offer?.financierDetails?.crmFinancierName === 'CHOLA');
          this.offerData = this.vcdata.includes(this.productDetailList?.vehicle_number) ? hdbofferData : res.offers;
        },
        error: () => {},
        complete: () => {},
      })
    );
  }

  getfinancer() {
    let data = {
      lob: this.productDetailList?.lob ? this.productDetailList?.lob : '',
      // ppl: this.productDetailList?.ppl ? this.productDetailList?.ppl : '',
      // pl: this.productDetailList?.pl ? this.productDetailList?.pl : '',
    };
    this.sub.add(
      this.apiService.financeDealerList(data).subscribe({
        next: (res: any) => {
          // this.financerData = res.data;
          const financeofferData = res.data.filter((offer) => offer.financier_name ===  "HDB Financial Services" || offer.financier_name ===  "HDFC Bank" ||offer.financier_name ===  "Cholamandalam");
          this.financerData = this.vcdata.includes(this.productDetailList?.vehicle_number) ? financeofferData : res.data;
         if(this.showBanner){
          this.bookingForm.patchValue({
            other_financier: this.financerData[0]?.financier_name,
          })
         }

        },
        error: () => {},
        complete: () => {},
      })
    );
  }

  setFinancierImgUrl(financierId: any) {
    return setImageUrl(financierId);
  }

  getDealer() {
    if (isPlatformBrowser(this.platformId)) {
    localStorage.removeItem("dealername")
    }
    {
      let data = {
        "dealer_code": this.codeDealer ? this.codeDealer : '',
        "action_type": "dropdown"
    };
    this.disableMainFields = false;
      this.sub.add(this.apiService.getDealerList(data).subscribe({
        next: (response: any) => {
          if (response["success"]== true) {
             this.dealIdData = response?.data?.[0]
             this.disableMainFields = true
             if (this.dealIdData) {

              this.bookingForm.patchValue({
                district: this.dealIdData.district,
                state: this.dealIdData.state,
                dealer: this.dealIdData.division_name,
                pincode: this.dealIdData.pincode,
              });
            }


         }
         else{
          // this.getStateList(this.productDetailList?.lob)
          this.disableMainFields = false;
         }
        },
        error: (error) => {
          this.toastrService.warning(error.data.msg);
        },
        complete: () => {
        }
      })
      );

    }
  
  }

  preventTab(event: KeyboardEvent) {
    if (event.key === 'Tab') {
      event.preventDefault();
    }
  }
  getPanValue(data:any){
    let pan=this.panInput.nativeElement.value;

    if (pan[3]!=='P' && pan?.length>3) {
      this.checkPan=true
    }
    else{
      this.checkPan=false
    }
  }
  getPanVal(data:any){
    let data1=data.target.value
    let pan=this.panInput.nativeElement.value;
    // const panRegex = /^([A-Z]){5}([0-9]){4}([A-Z]){1}?$/;
    // && panRegex.test(pan)
    if (data1?.length == 10 ) {
      if (pan[3]!=='P') {
        this.checkPan=true
      }
      else{
        this.checkPan=false
      }
    }
    else{
      this.checkPan=false
    }
  }

  gotoPath(path: any) {

    this.router.navigate([path]);
  }
  sanitizeInput(input: string): string {
    // Remove HTML tags
    return input.replace(/<\/?[^>]+(>|$)/g, '');
  }

  // Usage in the HTML
  onInput(event: any): void {
    const inputElement = event.target as HTMLInputElement;
    inputElement.value = this.sanitizeInput(inputElement.value);
  }
  nAllowSpace(event: KeyboardEvent) {
    if (event.key === ' ') {
      event.preventDefault();
    }
  }
}
export class PaymentResponse {
  razorpay_payment_id: string = '';
  razorpay_order_id: string = '';
  razorpay_signature: string = '';
}
